import * as React from 'react';
const SvgPlus = (props: React.SVGProps<SVGSVGElement>) => (
    <svg fill="none" height="1em" viewBox="0 0 24 24" width="1em" {...props}>
        <path
            clipRule="evenodd"
            d="M12 3a1 1 0 00-1 1v7H4a1 1 0 100 2h7v7a1 1 0 102 0v-7h7a1 1 0 100-2h-7V4a1 1 0 00-1-1z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);
export default SvgPlus;
